module.exports = require('./helpers/bundle-url').getBundleURL('6qsPi') + "svg-error-window.ffce7d1e.svg";